import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { incidentService } from "@iso/services";

/**
 * Who may author lessons learned, mirroring canManageLessonsLearned() in
 * IncidentLessonsLearnedController: Safety Admins, Owners and Admins, plus the
 * property's configured incident managers.
 *
 * Deliberately not useIsSafetyAdmin — that hook also guards the investigation
 * approve and submit flows, whose endpoints still require a strict Safety
 * Admin. Widening it there would render controls that come back 403.
 *
 * @returns {boolean} canManage
 */
const useCanManageLessonsLearned = () => {
  const [canManage, setCanManage] = useState(false);
  const activePropertyId = useSelector((state) => state.property.activePropertyId);
  const activePermission = useSelector((state) => state.permission?.activePermission);
  const currentUserId = useSelector((state) => state.user?.user?.id);

  useEffect(() => {
    if (!activePropertyId) return;
    incidentService
      .getSettings(activePropertyId)
      .then((response) => {
        const managerIds = response?.settings?.incident_manager_ids || [];
        const isManager = managerIds.some(
          (id) => Number(id) === Number(currentUserId)
        );
        setCanManage(
          !!response?.is_safety_admin ||
            ["owner", "admin"].includes(activePermission) ||
            isManager
        );
      })
      .catch((err) => {
        console.error("Failed to load incident settings", err);
      });
  }, [activePropertyId, activePermission, currentUserId]);

  return canManage;
};

export default useCanManageLessonsLearned;
